import React from "react";
import { Route, Routes } from "react-router-dom";
import CauseListPage from "../../Container/pages/CaseManagementSystem/CauseListPage";
import CaseStatusPage from "../../Container/pages/CaseManagementSystem/CaseStatusPage";
import JudgementPage from "../../Container/pages/CaseManagementSystem/JudgementPage";
import DailyOrderPage from "../../Container/pages/CaseManagementSystem/DailyOrderPage";
import CaseSearchPage from "../../Container/pages/CaseManagementSystem/CaseSearchPage";
import CaseUnderObjection from "../../Container/pages/CaseManagementSystem/CaseUnderObjection";

const CmsMenuRoutes = ({ benchId }) => {
  return (
    <Routes>
      <Route
        path="case-management-system/cause-list"
        element={<CauseListPage benchId={benchId} />}
      />
      <Route
        path="case-management-system/case-status"
        element={<CaseStatusPage benchId={benchId} />}
      />
      <Route
        path="case-management-system/judgement"
        element={<JudgementPage benchId={benchId} />}
      />
      <Route
        path="case-management-system/daily-order"
        element={<DailyOrderPage benchId={benchId} />}
      />
      <Route
        path="case-management-system/case-search"
        element={<CaseSearchPage benchId={benchId} />}
      />
      <Route
        path="case-management-system/case-under-objection"
        element={<CaseUnderObjection benchId={benchId} />}
      />
    </Routes>
  );
};

export default CmsMenuRoutes;
